import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import App1 from './App1';


if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
ReactDOM.render(
  <BrowserRouter>
    <div className="main_app_container">
      <div className="main_app_subcontainer">
        <App />
      </div>
    </div>
  </BrowserRouter>,
  document.getElementById('root')
);
}else{
  ReactDOM.render(
    <BrowserRouter>
      <div className="main_app_container">
        <div className="main_app_subcontainer">
          <App1 />
        </div>
      </div>
    </BrowserRouter>,
    document.getElementById('root')
  );
}